<template>
  <svg width="15" height="15" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.83572 9.04709L7.94744 7.16436C8.55668 6.3882 8.88725 5.42973 8.88603 4.44301C8.88603 3.56427 8.62545 2.70526 8.13724 1.97461C7.64904 1.24396 6.95514 0.674487 6.14328 0.338206C5.33143 0.00192507 4.43809 -0.0860614 3.57623 0.0853732C2.71437 0.256808 1.9227 0.679964 1.30133 1.30133C0.679964 1.9227 0.256808 2.71437 0.0853732 3.57623C-0.0860614 4.43809 0.00192507 5.33143 0.338206 6.14328C0.674487 6.95514 1.24396 7.64904 1.97461 8.13724C2.70526 8.62545 3.56427 8.88603 4.44301 8.88603C5.42973 8.88725 6.3882 8.55668 7.16436 7.94744L9.04709 9.83572C9.09872 9.88777 9.16014 9.92909 9.22782 9.95729C9.2955 9.98548 9.36809 10 9.4414 10C9.51472 10 9.58731 9.98548 9.65499 9.95729C9.72267 9.92909 9.78409 9.88777 9.83572 9.83572C9.88777 9.78409 9.92909 9.72267 9.95729 9.65499C9.98548 9.58731 10 9.51472 10 9.4414C10 9.36809 9.98548 9.2955 9.95729 9.22782C9.92909 9.16014 9.88777 9.09872 9.83572 9.04709ZM1.11076 4.44301C1.11076 3.78396 1.30619 3.1397 1.67234 2.59171C2.0385 2.04372 2.55892 1.61662 3.16781 1.36441C3.7767 1.1122 4.44671 1.04621 5.09311 1.17478C5.7395 1.30336 6.33325 1.62073 6.79928 2.08675C7.2653 2.55278 7.58267 3.14653 7.71125 3.79292C7.83982 4.43932 7.77383 5.10932 7.52162 5.71821C7.26941 6.32711 6.84231 6.84753 6.29432 7.21369C5.74633 7.57984 5.10207 7.77527 4.44301 7.77527C3.55924 7.77527 2.71167 7.4242 2.08675 6.79928C1.46183 6.17436 1.11076 5.32678 1.11076 4.44301Z" fill="#4D4D4D"/>
  </svg>
</template>

<script>

export default {
  name: 'LoupeIcon',
  components: {
  },
  props: {
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped>

</style>
